import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

import { AuthStore } from '../auth/auth.store';
import { needsOnboarding } from '../auth/onboarding.util';

/**
 * Bloquea el acceso al portal mientras el viticultor no haya cambiado la
 * contraseña inicial y completado sus datos de contacto. Lo mantiene en
 * /onboarding hasta que termine.
 */
export const onboardingGuard: CanActivateChildFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  authStore.hydrate();

  if (needsOnboarding(authStore.user())) {
    return router.createUrlTree(['/onboarding']);
  }

  return true;
};
